import * as React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { RoutesNew } from '../Routes';
import { MainMenuContainer } from '../MainMenu';
import { SeoUrlsContainer } from '../SeoUrls';
import { DemandActivityPopup } from '../../components/realtor_demand/demand_activity_popup';
import { selectSearchShown } from '../../selectors/searchShown';
import { selectCurrentPageMeta } from '../../selectors/pagesMeta';
import { selectPost } from '../../selectors/post';
import { useMeta } from '../../utils';
import { getPostMeta } from './helpers/getPostMeta';
import { IApplicationState } from '../../types/redux';
import { EType } from '../../repositories/journal/entities/page_info/PageInfoSchema';
import * as s from './LayoutNew.css';
import { AdfoxBannerFooter } from '../../components/AdfoxBanner';

export const LayoutNew = () => {
  const isSearchShown = useSelector(selectSearchShown);
  const location = useLocation();
  const { pathname } = location;
  const {
    metaTitle,
    metaDescription,
    metaKeywords,
    metaImage,
    canonicalUrl,
    type: pageType,
  } = useSelector((state: IApplicationState) => selectCurrentPageMeta(state, pathname));
  const post = useSelector(selectPost);

  useMeta(
    (pageType === EType.PostCard && getPostMeta(post)) || [
      metaTitle,
      metaDescription,
      metaKeywords,
      canonicalUrl,
      metaImage,
    ],
  );

  return (
    <div className={`${s['sections-wrapper']} ${isSearchShown ? s['_is-search-shown'] : ''}`}>
      <section className={s['wrapper']}>
        <div className={s['sidebar']}>
          <MainMenuContainer />
        </div>

        <div className={s['main-area']}>
          <RoutesNew />
        </div>
      </section>

      <section className={s['pre-footer']}>
        <div className={s['wrapper']}>
          <div className={s['pre-footer-main-area']}>
            <SeoUrlsContainer />
            <div className={s['pre-footer-sidebar-area']} />
          </div>

          <div className={s['adfox-banner-footer']}>
            <AdfoxBannerFooter />
          </div>
        </div>
      </section>

      <DemandActivityPopup pathname={pathname} />
    </div>
  );
};
